<template>
  <v-card elevation="1">
    <v-card-title class="d-flex flex-row" style="color: var(--darkBlue)">
      <v-row>
        <v-col class="text-lg-left text-center" lg="12" cols="12">
          <h3>{{ $t("navigationDrawerMenu.adminDefinedReports") }}</h3>
        </v-col>
      </v-row>
      <div>
        <v-tooltip bottom v-if="reportId">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-3"
              style="font-size: 32px"
              v-bind="attrs"
              v-on="on"
              @click="download"
            >
              mdi-download
            </v-icon>
          </template>
          <span>{{ $t("buttons.download") }}</span>
        </v-tooltip>
        <RefreshButton :refreshFunction="getItems"></RefreshButton>
      </div>
    </v-card-title>
    <v-row class="px-8 mt-2 mb-4">
      <FormElement
        key="REPORT_NAME_FILTER"
        v-model="reportId"
        :vertical="true"
        hide-details
        :validationLabel="$t('labels.reportType')"
        :topLabel="true"
        :labelShown="false"
        :cols="6"
        :xs="6"
        :sm="4"
        :lg="3"
        :xl="2"
        :onChange="runQuery"
        :formType="{
          name: 'multipleSelect',
          items: {
            data: items,
            text: 'Name',
            value: 'Id',
            disableAutoSelection: true,
          },
        }"
        :placeholder="$t('labels.reportType')"
        :classes="'mb-2'"
      />
      <FormElement
        key="START_DATE_FILTER"
        :vertical="true"
        v-model="startDate"
        hide-details
        :validationLabel="$t('labels.minOrderDate')"
        :topLabel="true"
        :labelShown="false"
        :cols="6"
        :xs="6"
        :sm="4"
        :lg="3"
        :xl="2"
        :onChange="runQuery"
        :formType="{
          name: 'date',
          dateMode: 'date',
        }"
        :placeholder="$t('labels.minOrderDate')"
        :classes="'mb-2'"
      />
      <FormElement
        key="End_DATE_FILTER"
        :vertical="true"
        v-model="endDate"
        hide-details
        :validationLabel="$t('labels.maxOrderDate')"
        :topLabel="true"
        :labelShown="false"
        :cols="6"
        :xs="6"
        :sm="4"
        :lg="3"
        :xl="2"
        :onChange="runQuery"
        :formType="{
          name: 'date',
          dateMode: 'date',
        }"
        :placeholder="$t('labels.maxOrderDate')"
        :classes="'mb-2'"
      />
      <FormElement
        key="SENDER_COUNTRY_ID"
        v-model="senderCountryId"
        :vertical="true"
        hide-details
        :validationLabel="$t('labels.senderCountry')"
        :topLabel="true"
        :labelShown="false"
        :cols="6"
        :xs="6"
        :sm="4"
        :lg="3"
        :xl="2"
        :onChange="
          () => {
            this.handleCountryChange(true);
          }
        "
        :formType="{
          name: 'multipleSelect',
          items: {
            data: senderCountries,
            text: 'Name',
            value: 'Id',
          },
        }"
        :placeholder="$t('labels.senderCountry')"
        :classes="'mb-2'"
      />
      <FormElement
        key="SENDER_CITY_ID"
        v-model="senderCityId"
        :vertical="true"
        hide-details
        :validationLabel="$t('labels.senderCity')"
        :topLabel="true"
        :labelShown="false"
        :cols="6"
        :xs="6"
        :sm="4"
        :lg="3"
        :xl="2"
        :onChange="runQuery"
        :formType="{
          name: 'multipleSelect',
          items: {
            data: senderCities,
            text: 'Name',
            value: 'Id',
          },
        }"
        :placeholder="$t('labels.senderCity')"
        :classes="'mb-2'"
      />
      <FormElement
        key="RECEIVER_COUNTRY_ID"
        v-model="receiverCountryId"
        :vertical="true"
        hide-details
        :validationLabel="$t('labels.receiverCountry')"
        :topLabel="true"
        :labelShown="false"
        :cols="6"
        :xs="6"
        :sm="4"
        :lg="3"
        :xl="2"
        :onChange="
          () => {
            this.handleCountryChange(false);
          }
        "
        :formType="{
          name: 'multipleSelect',
          items: {
            data: receiverCountries,
            text: 'Name',
            value: 'Id',
          },
        }"
        :placeholder="$t('labels.receiverCountry')"
        :classes="'mb-2'"
      />
      <FormElement
        key="RECEIVER_CITY_ID"
        v-model="receiverCityId"
        :vertical="true"
        hide-details
        :validationLabel="$t('labels.receiverCity')"
        :topLabel="true"
        :labelShown="false"
        :cols="6"
        :xs="6"
        :sm="4"
        :lg="3"
        :xl="2"
        :onChange="runQuery"
        :formType="{
          name: 'multipleSelect',
          items: {
            data: receiverCities,
            text: 'Name',
            value: 'Id',
          },
        }"
        :placeholder="$t('labels.receiverCity')"
        :classes="'mb-2'"
      />

      <FormElement
        key="INTEGRATION_LOGISCTIC_TYPE"
        v-model="integrationLogisticType"
        :vertical="true"
        hide-details
        :validationLabel="$t('titles.subsupplier')"
        :topLabel="true"
        :labelShown="false"
        :cols="6"
        :xs="6"
        :sm="4"
        :lg="3"
        :xl="2"
        :onChange="onLogisticChange"
        :formType="{
          name: 'multipleSelect',
          items: {
            data: logistics,
            text: 'Name',
            value: 'Id',
          },
        }"
        :placeholder="$t('titles.subsupplier')"
        :classes="'mb-2'"
      />

      <FormElement
        key="INTEGRATION_LOGISCTIC_SUB_TYPE"
        v-model="integrationLogisticSubType"
        :vertical="true"
        hide-details
        :validationLabel="$t('titles.integrationService')"
        :topLabel="true"
        :labelShown="false"
        :cols="6"
        :xs="6"
        :sm="4"
        :lg="3"
        :xl="2"
        :onChange="runQuery"
        :active="!!integrationLogisticType"
        :hidden="!integrationLogisticType"
        :formType="{
          name: 'multipleSelect',
          items: {
            data: logisticTypes,
            text: 'value',
            value: 'value',
          },
        }"
        :placeholder="$t('titles.integrationService')"
        :classes="'mb-3'"
      />

      <FormElement
        key="ORDER_STATUS"
        v-model="orderStatus"
        :vertical="true"
        hide-details
        :validationLabel="$t('labels.orderStatus')"
        :topLabel="true"
        :labelShown="false"
        :cols="6"
        :xs="6"
        :sm="4"
        :lg="3"
        :xl="2"
        :onChange="runQuery"
        :formType="{
          name: 'multipleSelect',
          items: {
            data: orderStatuses,
            text: 'name',
            value: 'value',
          },
        }"
        :placeholder="$t('labels.orderStatus')"
        :classes="'mb-2'"
      />

      <FormElement
        key="ORDER_PAYMENT_STATUS"
        v-model="orderPaymentStatus"
        :vertical="true"
        hide-details
        :validationLabel="$t('labels.paymentStatus')"
        :topLabel="true"
        :labelShown="false"
        :cols="6"
        :xs="6"
        :sm="4"
        :lg="3"
        :xl="2"
        :onChange="runQuery"
        :formType="{
          name: 'multipleSelect',
          items: {
            data: orderPaymentStatuses,
            text: 'name',
            value: 'value',
          },
        }"
        :placeholder="$t('labels.paymentStatus')"
        :classes="'mb-3'"
      />

      <FormElement
        key="CUSTOMER_NAME"
        v-model="customerName"
        :active="isSupplier"
        :hidden="!isSupplier"
        :vertical="true"
        hide-details
        :validationLabel="$t('labels.customerName')"
        :topLabel="true"
        :labelShown="false"
        :cols="6"
        :xs="6"
        :sm="4"
        :lg="3"
        :xl="2"
        :onChange="runQuery"
        :formType="{
          name: 'text',
          appendIcon: 'mdi-magnify',
          appendClick: getSearchDebounced,
        }"
        :placeholder="$t('labels.customerName')"
        :classes="'mb-3'"
        @input="getSearchDebounced"
      />

      <FormElement
        key="ORDER_TYPES"
        v-model="orderType"
        :vertical="true"
        hide-details
        :validationLabel="$t('titles.orderType')"
        :topLabel="true"
        :labelShown="false"
        :cols="6"
        :xs="6"
        :sm="4"
        :lg="3"
        :xl="2"
        :onChange="runQuery"
        :formType="{
          name: 'multipleSelect',
          items: {
            data: orderTypes,
            text: 'name',
            value: 'value',
          },
        }"
        :placeholder="$t('titles.orderType')"
        :classes="'mb-3'"
      />
      <FormElement
        key="SHIPMENT_CREATE_TYPE"
        v-model="shipmentCreateType"
        :vertical="true"
        hide-details
        :validationLabel="$t('titles.shipmentCreateType')"
        :topLabel="true"
        :labelShown="false"
        :cols="6"
        :xs="6"
        :sm="4"
        :lg="3"
        :xl="2"
        :onChange="runQuery"
        :formType="{
          name: 'multipleSelect',
          items: {
            data: shipmentCreateTypes,
            text: 'name',
            value: 'value',
          },
        }"
        :placeholder="$t('titles.shipmentCreateType')"
        :classes="'mb-3'"
      />

      <FormElement
        key="IS_PLANNED"
        v-model="isPlanned"
        :vertical="true"
        hide-details
        :validationLabel="$t('titles.isPlanned')"
        :topLabel="true"
        :labelShown="false"
        :cols="6"
        :xs="6"
        :sm="4"
        :lg="3"
        :xl="2"
        :onChange="runQuery"
        :formType="{
          name: 'multipleSelect',
          items: {
            data: [
              {
                name: $t('labels.All'),
                value: -1,
              },
              {
                name: $t('buttons.yes'),
                value: true,
              },
              {
                name: $t('buttons.no'),
                value: false,
              },
            ],
            text: 'name',
            value: 'value',
          },
        }"
        :placeholder="$t('titles.isPlanned')"
        :classes="'mb-3'"
      />
    </v-row>
    <v-divider />
    <v-card-text>
      <v-data-table
        :headers="selectedViewHeaders"
        :items="viewRows"
        hide-default-footer
        :loading="query.loading"
        :options="{
          itemsPerPage: itemsPerPage,
        }"
        :item-key="'Id'"
        :no-data-text="$t('messages.noData')"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td class="text-center" v-for="row in selectedViewHeaders">
              {{ getRowValue(item, row) }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-pagination
        v-if="queryPageLength > 0"
        class="my-4"
        @input="query.onChange"
        v-model="query.page"
        :length="queryPageLength"
        :total-visible="10"
        circle
      ></v-pagination>
    </v-card-text>
  </v-card>
</template>
<script>
import {
  downloadFile,
  getCountries,
  getCities,
  ITEMS_PER_PAGE_OPTIONS,
} from "../utils/constants";
import FormElement from "../components/FormElement.vue";
import RefreshButton from "../components/RefreshButton.vue";
import TabScreen from "../components/TabScreen.vue";
import AnnouncementService from "../services/AnnouncementService";
import AdminReportService from "../services/AdminReportService";
import CheckTable from "../components/CheckTable.vue";
import IntegrationService from "../services/IntegrationService";
import PortalService from "../services/PortalService";

export default {
  data() {
    return {
      items: [],

      // States
      itemsPerPage: 10,
      page: 1,
      totalItems: 0,
      perPageValues: [
        {
          name: "5",
          value: 5,
        },
        {
          name: "10",
          value: 10,
        },
        {
          name: "15",
          value: 15,
        },
        {
          name: "30",
          value: 30,
        },
        {
          name: "50",
          value: 50,
        },
        {
          name: "100",
          value: 100,
        },
        {
          name: this.$t("labels.All"),
          value: 9999,
        },
      ],
      isEditMode: false,

      actionsModal: false,
      form: {
        ValidityDate: "",
      },

      slots: [],
      centralBankExchangeRateList: [],
      selectedTab: 0,
      dateFilter: new Date(),

      startDate: null,
      endDate: null,

      senderCountryId: null,
      senderCityId: null,
      receiverCountryId: null,
      receiverCityId: null,

      senderCountries: [],
      senderCities: [],
      receiverCountries: [],
      receiverCities: [],

      integrationLogisticType: null,
      integrationLogisticSubType: null,

      logisticTypes: [],

      orderPaymentStatus: null,
      orderPaymentStatuses: [
        {
          name: this.$t("labels.All"),
          value: -1,
        },
        {
          name: this.$t("labels.paymentCompleted"),
          value: 0,
        },
        {
          name: this.$t("labels.paymentIncomplete"),
          value: 1,
        },
        {
          name: this.$t("messages.waitingForPaymentApproval"),
          value: 2,
        },
        {
          name: this.$t("messages.extraPayment"),
          value: 3,
        },
        {
          name: this.$t("messages.returnPayment"),
          value: 4,
        },
      ],

      customerName: null,

      orderType: -1,
      orderTypes: [
        {
          name: this.$t("labels.All"),
          value: -1,
        },
        {
          name: "Manuel",
          value: 0,
        },
        {
          name: "Etsy",
          value: 1,
        },
        {
          name: "Amazon",
          value: 2,
        },
      ],

      shipmentCreateType: null,
      shipmentCreateTypes: [
        {
          name: this.$t("labels.All"),
          value: -1,
        },
        {
          name: this.$t("labels.priceSearch"),
          value: 0,
        },
        {
          name: this.$t("labels.spotOfferLabel"),
          value: 1,
        },
        {
          name: this.$t("navigationDrawerMenu.publicApi"),
          value: 2,
        },
      ],

      isPlanned: -1,

      debounceTimeout: null,

      logistics: [
        {
          Name: "FedEx",
          Id: 1,
        },
        {
          Name: "UPS",
          Id: 2,
        },
      ],

      orderStatus: null,
      orderStatuses: [],

      file: {
        loading: "",
        data: null,
        url: "",
      },

      isSupplier: null,
      companyCategory: null,

      viewHeaders: [],
      viewName: null,

      reportId: null,
      query: {
        data: [],
        sql: null,
        loading: false,
        page: 1,
        pageSize: 15,
        onChange: () => {
          this.runQuery();
        },
        totalItems: 0,
      },
    };
  },
  components: { FormElement, RefreshButton, TabScreen, CheckTable },
  mounted() {
    this.itemsPerPageOptions = ITEMS_PER_PAGE_OPTIONS;
    this.setup();

    this.isSupplier = this.$store.state.Type === "Supplier";
    this.companyCategory =
      this.$store.state.Type === "Admin" ? null : this.isSupplier ? 3 : 1;

    let statuses = [
      {
        name: this.$t("labels.All"),
        value: null,
      },
      {
        name: this.$t("labels.labelsOrderStatuses.detail"),
        value: 0,
      },
      {
        name: this.$t("labels.labelsOrderStatuses.payment"),
        value: 2,
      },
      {
        name: this.$t("labels.labelsOrderStatuses.paymentApproved"),
        value: 1,
      },
      {
        name: this.$t("labels.labelsOrderStatuses.approved"),
        value: 3,
      },
      {
        name: this.$t("labels.labelsOrderStatuses.loaded"),
        value: 4,
      },
      {
        name: this.$t("labels.labelsOrderStatuses.shipping"),
        value: 5,
      },
      {
        name: this.$t("labels.labelsOrderStatuses.inDestination"),
        value: 6,
      },
      {
        name: this.$t("labels.labelsOrderStatuses.delivered"),
        value: 7,
      },
      {
        name: this.$t("labels.labelsOrderStatuses.archived"),
        value: 8,
      },
      {
        name: this.$t("labels.labelsOrderStatuses.canceled"),
        value: 9,
      },
    ];

    if (
      this.$store.state.Type === "Supplier" ||
      this.$store.state.Type === "PendingSupplier"
    ) {
      statuses = statuses.filter((status) => ![0, 2].includes(status.value));
    }

    this.orderStatuses = statuses;
  },
  computed: {
    queryPageLength() {
      return Math.ceil(this.query.totalItems / this.query.pageSize);
    },
    viewRows() {
      if (this.query.data.length > 0 && !this.viewName) return this.query.data;

      if (this.viewHeaders?.length === 0) return [];

      return this.viewHeaders[this.viewName]?.Rows || [];
    },

    selectedViewHeaders() {
      const firstObject = this.viewRows[0];

      if (!firstObject) return [];

      return Object.keys(firstObject).map((header) => ({
        text: header,
        value: header,
        sortable: false,
        groupable: false,
        cellClass: "regular-cell",
        align: "center",
      }));
    },

    viewNames() {
      if (this.viewHeaders?.length === 0) return [];

      return Object.keys(this.viewHeaders).map((key) => ({
        name: this.viewHeaders[key]?.View,
        value: key,
      }));
    },

    formItems() {
      return [
        {
          key: {
            parent: "form",
            child: "Name",
          },
          rules: "required",
          validationLabel: "labels.name",
          formType: {
            name: "text",
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          placeholder: "labels.name",
        },
        {
          key: {
            parent: "form",
            child: "CompanyCategory",
          },
          rules: "required",
          validationLabel: "labels.companyType",
          formType: {
            name: "select",
            items: {
              data: this.$companyCategories,
              text: "name",
              value: "value",
            },
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          placeholder: "labels.companyType",
        },
        {
          key: {
            parent: "form",
            child: "SQL",
          },
          rules: "required",
          validationLabel: "labels.sql",
          formType: {
            name: "textarea",
            append: "mdi-database-search",
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          placeholder: "labels.sql",
        },
      ];
    },

    pageLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },
  methods: {
    getSearchDebounced() {
      if (!this.customerName) return;
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.totalItems = 15;
        this.pageSize = 15;
        this.page = 1;

        this.runQuery();
      }, 300);
    },
    onLogisticChange() {
      if (!this.integrationLogisticType) {
        this.runQuery();
        return;
      }

      this.$store.state.loadingStatus = true;
      PortalService.getIntegrationServices(this.integrationLogisticType)
        .then((response) => {
          this.logisticTypes = response.data;
        })
        .catch((err) => {
          window.showError(err);
        })
        .finally(() => {
          this.$store.state.loadingStatus = false;
          this.runQuery();
        });
    },

    async handleCountryChange(isSender) {
      const selectedCountryId = isSender
        ? this.senderCountryId
        : this.receiverCountryId;

      if (!selectedCountryId) {
        if (isSender) {
          this.senderCityId = null;
          this.senderCities = [];
        } else {
          this.receiverCityId = null;
          this.receiverCities = [];
        }

        await this.runQuery();
        return;
      }

      const cities = await getCities(selectedCountryId);

      if (isSender) {
        this.senderCities = cities;
        this.senderCityId = null;
      } else {
        this.receiverCities = cities;
        this.receiverCityId = null;
      }

      this.runQuery();
    },
    download() {
      if (!this.reportId) return;

      this.$store.state.loadingStatus = true;
      AdminReportService.downloadExcels(this.query.sql)
        .then((response) => {
          const data = response.data;
          if (data) {
            downloadFile(
              data,
              `${Date.now()}_SQLReport_${this.reportId}`,
              "xlsx"
            );
          }
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    getRowValue(item, row) {
      if (!item || !row) return;

      const rowValue = item[row["text"]];
      const type = typeof rowValue;
      let value = rowValue;

      if (type === "object") {
        value = "-";
      } else if (type !== "number") {
        const isDate = !isNaN(new Date(rowValue).getTime());
        if (isDate) {
          value = convertToLocal(rowValue);
        }
      }

      return value;
    },

    async runQuery() {
      if (!this.reportId) return;

      this.$store.state.loadingStatus = true;
      AdminReportService.getReportResults({
        ReportId: this.reportId,
        Page: this.query.page,
        PageSize: this.query.pageSize,
        StartDate: this.startDate,
        EndDate: this.endDate,
        SenderCountryId: this.senderCountryId,
        SenderCityId: this.senderCityId,
        ReceiverCountryId: this.receiverCountryId,
        ReceiverCityId: this.receiverCityId,
        IntegrationLogisticType: this.integrationLogisticType,
        OrderStatus: this.orderStatus,
        ExpressServiceType: this.integrationLogisticSubType,
        OrderPaymentStatus: this.orderPaymentStatus,
        CustomerName: this.customerName,
        OrderType: this.orderType,
        ShipmentCreateType: this.shipmentCreateType,
        IsPlanned: this.isPlanned,
      })
        .then((response) => {
          const data = response.data.Result;
          if (data) {
            this.query.data = data.Data;
            this.query.sql = data.SqlQuery;
            this.query.totalItems = response.data.TotalItems;
          }
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    async getCompanies() {
      this.$store.state.loadingStatus = true;
      AnnouncementService.getCompaniesForAnnouncements()
        .then((response) => {
          const data = response.data;
          if (data) {
            this.companies = response.data.Result;
          }
        })
        .catch(window.showError)
        .finally(() => (this.$store.state.loadingStatus = false));
    },

    async setup() {
      this.getItems();

      const countries = await getCountries();
      this.senderCountries = countries;
      this.receiverCountries = countries;
    },

    /**
     * Get search history from service.
     */
    getItems() {
      this.$store.state.loadingStatus = true;
      AdminReportService.getAll({
        Page: this.page,
        PageSize: 999999,
        CompanyCategory: this.companyCategory,
      })
        .then((response) => {
          this.items = response.data.Result;
          this.totalItems = response.data.TotalItems;
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
  },
};
</script>
<style></style>
